import { isNil } from 'lodash';
import { MaybeNil } from '../../../../utils/interfaces';
import { IRetentionStyle } from '../types';
import { IRetentionRange } from '../../interfaces';

const scalePercent = (unscaled: number, range: IRetentionRange): number => {
  if (range.max === range.min) {
    return 0;
  }
  return (unscaled - range.min) / (range.max - range.min);
};

export default (
  unscaledPercentValue: MaybeNil<number>,
  colorTable: IRetentionStyle[],
  range: IRetentionRange,
) => {
  let cappedPercentValue = 0;
  if (!isNil(unscaledPercentValue)) {
    let percentValue = scalePercent(unscaledPercentValue, range);
    if (percentValue < 0) {
      cappedPercentValue = 0;
      console.warn('Negative percent: ', percentValue);
    } else if (percentValue > 1) {
      percentValue = 1;
      console.warn('Percent above >1', percentValue);
    } else {
      cappedPercentValue = percentValue;
    }
  }

  const numStyles = colorTable.length - 1; // first index is for zeros
  const styleIndex = Math.ceil(cappedPercentValue * numStyles);
  const style = colorTable[styleIndex];

  return {
    backgroundColor: style.backgroundColor,
    fontColor: style.foregroundColor,
    iconKey: style.liveIconKey,
  };
};
